export default __webpack_public_path__ + "static/media/ic_person_focus_on.1a63c8f2.png";